import Style from "./style"

import DefaultButton from "shared/ui/DefaultButton"
import notMobileIcon from "shared/assets/ic_not_mobile.svg"

const NotMobileModal = ({ closeEvent }) => {
    

    return (
        <Style.ModalBackground>
            <Style.Modal>
                <Style.LogoMobile
                    src={notMobileIcon}
                    alt="프랜차이즈 로고"
                />
                <Style.ContainerContent>
                    <Style.Title>모바일에서는 사용할 수 없습니다</Style.Title>
                    <Style.Content>이 기능은 컴퓨터에서 사용해 주세요.</Style.Content>
                </Style.ContainerContent>
                <DefaultButton small fitWidth expandHeight clickEvent={closeEvent}>닫다</DefaultButton>
            </Style.Modal>
        </Style.ModalBackground>
    )
}

export default NotMobileModal